'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'face-confused';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e36d';
var svgPathData = ['M16 256a240 240 0 1 0 480 0 240 240 0 1 0 -480 0zM146.1 397.4c-3-3.3-2.7-8.3 .5-11.3l5.6-5.1c54.5-49.5 125.5-77 199.1-77l8.7 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-8.7 0c-69.7 0-136.8 26-188.3 72.8l-5.6 5.1c-3.3 3-8.3 2.7-11.3-.5zM192 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm160 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0z', 'M496 256a240 240 0 1 0 -480 0 240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM163 392.8l-5.6 5.1c-3.3 3-8.3 2.7-11.3-.5s-2.7-8.3 .5-11.3l5.6-5.1c54.5-49.5 125.5-77 199.1-77l8.7 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-8.7 0c-69.7 0-136.8 26-188.3 72.8zM160 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm176-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceConfused = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;